import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ToolbarComponent } from '../toolbar/toolbar.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [ToolbarComponent, RouterModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {}
